import { render, staticRenderFns } from "./Planificacion.vue?vue&type=template&id=48311e6c&scoped=true"
import script from "./Planificacion.vue?vue&type=script&lang=js"
export * from "./Planificacion.vue?vue&type=script&lang=js"
import style0 from "./Planificacion.vue?vue&type=style&index=0&id=48311e6c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48311e6c",
  null
  
)

export default component.exports